import { formatOptionsSummary } from '../options-utils'
import OptionsSummaryLabel from './OptionsSummaryLabel'
import React from 'react'
import type { ProductOptionProps } from '../Module'
import type { MouseEventHandler } from 'react'

interface OptionsSummaryProps {
  onEdit?: MouseEventHandler<HTMLAnchorElement>
  options: ProductOptionProps[]
}

export default function OptionsSummary({
  onEdit,
  options = [],
}: OptionsSummaryProps) {
  if (options.length === 0) {
    return null
  }

  const labels = formatOptionsSummary(options)
  const updateLabel =
    options.length > 1 ? '(modifier les options)' : '(modifier)'

  if (labels.length >= 1) {
    return (
      <OptionsSummaryContent
        labels={labels}
        onEdit={onEdit}
        updateLabel={updateLabel}
      />
    )
  }

  // Do not ask for option creation when editing is forbidden
  if (!onEdit) {
    return null
  }

  const addLabel =
    options.length > 1 ? '(ajouter des options)' : '(ajouter une option)'

  return (
    <a href='#' onClick={onEdit}>
      {addLabel}
    </a>
  )
}

function OptionsSummaryContent({
  labels,
  onEdit,
  updateLabel,
}: {
  labels: string[][]
  onEdit?: MouseEventHandler<HTMLAnchorElement>
  updateLabel?: string
}) {
  if (labels.length === 1) {
    const [title, labelValues] = labels[0]

    const [label, remainingLabels] = Array.isArray(labelValues)
      ? labelValues
      : [labelValues]

    return (
      <div>
        <OptionsSummaryLabel
          label={remainingLabels ? '' : label}
          title={title}
        />
        {remainingLabels && <OptionsSummaryContent labels={remainingLabels} />}
        {onEdit && (
          <>
            &nbsp;
            <a href='#' onClick={onEdit}>
              {updateLabel}
            </a>
          </>
        )}
      </div>
    )
  } else if (labels.length > 1) {
    return (
      <>
        {labels.map((data, index) =>
          Array.isArray(data) ? (
            <div key={`${data[0]}-${index}`}>
              <OptionsSummaryLabel label={data[1]} title={data[0]} />
            </div>
          ) : (
            <OptionsSummaryLabel
              label={data}
              title={''}
              key={`${data}-${index}`}
            />
          )
        )}
        {onEdit && (
          <a href='#' onClick={onEdit}>
            {updateLabel}
          </a>
        )}
      </>
    )
  }
}
